
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services/hotels",
      function () {
        return require("private-next-pages/services/hotels.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/services/hotels"])
      });
    }
  